<template>
  <div
    id="content-code">
    <v-divider></v-divider>

    <!-- Edit Form -->
    <form
      name="codeContentItemForm"
      class="mt-5"
      v-if="tab === 'edit'"
      @submit.prevent="updateContentItem('codeItemUpdate')">
      <v-textarea
        class="code-line-height"
        v-model="contentItem.content"
        hide-details
        outlined
        >
      </v-textarea>

      <div class="page-buttons d-flex my-5">
        <v-btn
          type="submit"
          color="primary">
          Save
        </v-btn>

        <v-btn
          @click="goToContentList"
          type="button"
          color="primary"
          class="mr-auto order-first"
          outlined>
          Cancel
        </v-btn>
      </div>
    </form>
    <!-- / Edit Form -->

    <!-- Revisions -->
    <Revisions
      v-if="tab === 'revisions'"
    />
    <!-- / Revisions -->
  </div>
</template>

<script>
import ContentItemMixin from '../mixin.content-item';
import Revisions from './Revisions.vue';

export default {
  name: 'ContentCode',
  props: ['tab'],
  mixins: [
    ContentItemMixin,
  ],
  components: {
    Revisions,
  },
};
</script>

<style lang="scss">
    .code-line-height {
      font-family: 'Courier New', Courier, monospace!important;
    }

    .code-line-height .v-input__control .v-input__slot .v-text-field__slot textarea {
      line-height: 25px!important;
      min-height: 50vh;
    }
</style>
